import React from 'react';
import { Modal, ModalHeader, ModalTitle, ModalContent } from '../../../../components/ui';
import ApprovalEntitySummary from '../../../../components/generic/ApprovalEntitySummary';
import ApprovalIntegration from '../../components/ApprovalIntegration';

/**
 * Custom Form Component for Approval Requests
 * This form opens the "Request Document Review and Approval Status" form
 * Used for both add and edit operations
 */
const ApprovalIntegrationForm = ({
  isOpen,
  formMode,
  formData,
  selectedRecord,
  config,
  onClose,
  onSubmit,
  isLoading
}) => {
  if (!isOpen) return null;

  // Determine if this is edit mode
  const isEditMode = formMode === 'edit' && selectedRecord;

  // Get entity information from selectedRecord or formData
  const entityType = selectedRecord?.entityType?.name || formData?.entityType?.name || 'document';
  const entityId = selectedRecord?.entityId || formData?.entityId;
  const entityData = selectedRecord?.entityData || formData?.entityData || {
    documentCode: selectedRecord?.code || formData?.code,
    documentTitle: selectedRecord?.title || formData?.title,
    documentType: selectedRecord?.entityType?.name || formData?.entityType?.name,
    description: selectedRecord?.description || formData?.description
  };

  const handleFormSubmit = async (approvalData) => {
    console.log('ApprovalIntegrationForm submit:', approvalData);
    // The ApprovalIntegration component handles the save/update internally
    // Don't call onSubmit here - it expects an event object, not approval data
    // The parent component (GenericFormsPage) will refresh via SWR invalidation
    // Just close the form after a short delay to show success
    setTimeout(() => {
      onClose();
    }, 500);
  };

  const handleFormCancel = () => {
    console.log('ApprovalIntegrationForm cancelled');
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleFormCancel} size="lg">
      <ModalHeader>
        <ModalTitle>
          {isEditMode 
            ? 'Request Document Review and Approval Status'
            : 'Request Document Review and Approval Status'}
        </ModalTitle>
      </ModalHeader>
      <ModalContent>
        <ApprovalEntitySummary entityData={entityData} />
        <ApprovalIntegration
          entityType={entityType}
          entityId={entityId}
          entityData={entityData}
          existingApproval={isEditMode ? selectedRecord : null}
          onSubmit={handleFormSubmit}
          onCancel={handleFormCancel}
          isLoading={isLoading}
          isEditMode={isEditMode}
        />
      </ModalContent>
    </Modal>
  );
};

export default ApprovalIntegrationForm;

